<div *ngIf="customField13==0">

  <div *ngIf="newPopup === 2" class="new-popup-styles"  fxShow fxHide.lt-md>

    <div fxLayout="row wrap" fxFlex="100" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">

      <ng-container *ngFor="let field of fields">
        <ng-container *ngIf="!field.enableConditionalField || field.visible">
          <ng-container *ngIf="field.inputType !== 'button'; else buttonContainer" class="inner-type-three">
            <div   [fxFlex]="layout == 2 ? 
            (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
            : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
              : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
                : '100'))" >
                    <div [whiteFields]="whiteFields"  dynamicField (valueChange)="onFieldValueChange($event)" [field]="field" [group]="form"  ></div>
                  </div>


          </ng-container>
          <ng-template #buttonContainer >
            <div *ngIf="EnablePayment==0 && !enableFormPayment" fxFlex="100">
              <button  (click)="onSubmit()" fxFlex type="submit" style="color:white" mat-raised-button
              class="primar new-submit-button">aa{{field.label}}</button>
            </div>

          </ng-template>
          </ng-container>

      </ng-container>
      <div *ngIf="formValid && enableFormPayment">
        <app-razor-pay [contact]="contact" [partialAmountEnabled]="0" (paymentStatus)="paymentResponceRazorPAy($event)"
          [finalAmount]="amount"></app-razor-pay>

      </div>
    </div>
  </div>


  <div fxLayout="row " *ngIf="formInit" fxShow fxHide.lt-md>
    <div fxLayout="row wrap" fxFlex="100" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">

      <ng-container *ngFor="let field of fields">

        <ng-container *ngIf="!field.enableConditionalField || field.visible">

          <ng-container *ngIf="field.inputType !== 'button'; else buttonContainer">
            <div [fxFlex]="layout == 2 ? 
          (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
          : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
            : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
              : '100'))">

              <div dynamicField (valueChange)="onFieldValueChange($event)" [whiteFields]="whiteFields" [field]="field" [group]="form"></div>
            </div>
          </ng-container>
          <ng-template #buttonContainer>
            <div *ngIf="EnablePayment==0 && !enableFormPayment" [fxFlex]="whiteFields == false ? 100 : ''" fxLayout="row" fxLayoutAlign="center center">


              <button class="primary" [ngClass]="whiteFields == true ? 'whitebox' : ''"  [ngStyle]="{ 'color': disabledButton? 'gray' : 'white' }"
                [disabled]="disabledButton" (click)="onSubmit()" mat-raised-button>

               {{disabledButton?'Processing': field.label}}
                <mat-icon *ngIf="disabledButton">
                  <mat-spinner class="primary" diameter="20">
                  </mat-spinner>
                </mat-icon>
              </button>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>

      <div *ngIf="formValid && enableFormPayment">
        <app-razor-pay [contact]="contact" [partialAmountEnabled]="0" (paymentStatus)="paymentResponceRazorPAy($event)"
          [finalAmount]="amount"></app-razor-pay>

      </div>

    </div>
  </div>
</div>

<div *ngIf="customField13==0">
  <div     *ngIf="newPopup === 2" class="new-popup-styles" fxLayout="row"  fxShow fxHide.gt-sm>
   <div fxLayout="row wrap" fxFlex="100" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">
      <ng-container *ngFor="let field of fields">
        <ng-container *ngIf="!field.enableConditionalField || field.visible">
          <ng-container *ngIf="field.inputType !== 'button'; else buttonContainer">
            <div [fxFlex]="layout == 2 ? 
            (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
            : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
              : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
                : '100'))">
                    <div  dynamicField (valueChange)="onFieldValueChange($event)" [field]="field" [group]="form"></div>
                  </div>


          </ng-container>
          <ng-template #buttonContainer>
            <div *ngIf="EnablePayment==0 && !enableFormPayment" fxFlex="100">
              <button (click)="onSubmit()" fxFlex type="submit" style="color:white" mat-raised-button
              class="primary">{{field.label}}</button>
            </div>

          </ng-template>
          </ng-container>

      </ng-container>
      <div *ngIf="formValid && enableFormPayment">
        <app-razor-pay [contact]="contact" [partialAmountEnabled]="0" (paymentStatus)="paymentResponceRazorPAy($event)"
          [finalAmount]="amount"></app-razor-pay>

      </div>
    </div>
  </div>

  <div *ngIf="formInit" fxShow fxHide.gt-sm fxLayout="column">
    <div style="box-sizing: border-box;width: 100%;" [formGroup]="form" [fxLayoutGap]="gapBetweenImage"
      fxLayout="column">

      <ng-container *ngFor="let field of fields" style="width: 100%;">
        <ng-container *ngIf="!field.enableConditionalField || field.visible">
          <ng-container *ngIf="field.inputType !== 'button'; else buttonContainer" style="width: 100%;">
            <div [fxFlex]="layout == 2 ? 
        (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
        : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
          : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
            : '100'))">
              <div dynamicField [field]="field" [group]="form"></div>
            </div>
          </ng-container>
          <ng-template #buttonContainer>
            <div *ngIf="EnablePayment==0 && !enableFormPayment" fxFlex="100">
              <!-- <button (click)="onSubmit()" fxFlex type="submit" style="color:white" mat-raised-button
                class="primary">{{field.label}}</button> -->


              <button class="primary" fxFlex [ngStyle]="{ 'color': disabledButton? 'gray' : 'white' }"
                [disabled]="disabledButton" (click)="onSubmit()" mat-raised-button>

                {{disabledButton?'Processing': field.label}}
                <mat-icon *ngIf="disabledButton">
                  <mat-spinner class="primary" diameter="20">
                  </mat-spinner>
                </mat-icon>
              </button>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>

      <div *ngIf="formValid && enableFormPayment">
        <app-razor-pay [contact]="contact" [partialAmountEnabled]="0" (paymentStatus)="paymentResponceRazorPAy($event)"
          [finalAmount]="amount">
        </app-razor-pay>

      </div>

    </div>
  </div>
</div>

<div *ngIf="customField13==1" fxLayoutAlign="center center">

  <div *ngIf="formInitSecond;else other_content">

    <calsoft-sub-form [layout]="layout" (submit)="submitSecondForm($event)" [formGroupId]="newFormField">
    </calsoft-sub-form>
  </div>

  <ng-template #other_content>

    <div fxLayout="row" class="cards" fxLayoutAlign="center center" *ngIf="formInit">
      <div fxLayout="row wrap" fxFlex="100" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">

        <ng-container>

          <div fxLayout="column">
            <div fxLayout="row wrap" fxLayoutAlign="start start">
              <div *ngFor="let field of valuesInputed; let i = index">

                <div *ngIf="form.value[field]!=null &&form.value[field]!=undefined ">
                  <div *ngIf="form.value[field].length>0">
                    <div *ngIf="!field.includes('image')" class="button-cards" (click)="goToState(i)">
                      {{ form.value[field] }}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>



          <ng-container>
            <div [fxFlex]="'100'">
              <button style="border: none; margin-top: 5px;" (click)="back()" *ngIf="dontDisplayBackButton">

                <mat-icon>keyboard_backspace</mat-icon>

              </button>

              <div *ngIf="formInit1">


                <div *ngIf="objectTobeDisplayed.inputType=='image'">

                  <calsoft-image (valueChange)="onFieldValueChange($event)" [field]="objectTobeDisplayed"
                    [group]="form">

                  </calsoft-image>
                </div>


                <div *ngIf="objectTobeDisplayed.inputType=='select'">
                  <calsoft-select (valueChange)="onFieldValueChange($event)" [field]="objectTobeDisplayed"
                    [group]="form">
                  </calsoft-select>
                </div>

                <div *ngIf="objectTobeDisplayed.inputType=='text'">

                  <div>
                    <calsoft-input [customField13]="customField13" (valueChange)="onFieldValueChange($event)"
                      [field]="objectTobeDisplayed" [group]="form">
                    </calsoft-input>

                  </div>




                </div>

                <div *ngIf="objectTobeDisplayed.inputType=='file'">

                  <calsoft-file-upload (valueChange)="onFieldValueChangeImage($event)" [customField13]="customField13"
                    [field]="objectTobeDisplayed" [group]="form">
                  </calsoft-file-upload>



                </div>


                <div *ngIf="objectTobeDisplayed.inputType=='button'">
                  <div fxFlex="100" [formGroup]="form">

                    <ng-container *ngFor="let field of fields">
                      <ng-container *ngIf="field.inputType == 'button'">


                        <button class="primary" fxFlex [ngStyle]="{ 'color': disabledButton? 'gray' : 'white' }"
                          [disabled]="disabledButton" (click)="onSubmit()" mat-raised-button>

                          {{disabledButton?'Processing': field.label}}
                          <mat-icon *ngIf="disabledButton">
                            <mat-spinner class="primary" diameter="20">
                            </mat-spinner>
                          </mat-icon>
                        </button>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>


              </div>


            </div>
          </ng-container>

        </ng-container>

      </div>
    </div>
  </ng-template>
</div>
<div *ngIf="customField13==2" fxLayoutAlign="center center">

  <div *ngIf="formInitSecond">

    <calsoft-sub-form [layout]="layout" (submitSubForm)="SecondFormSubmitnew($event)" [formGroupId]="newFormField">
    </calsoft-sub-form>

    <div *ngIf="customField13==2" class="gapbottom" fxLayoutAlign="end center">
      <button fxFlex="100" (click)="newForm()" style="color:white" mat-raised-button class="primary">Submit</button>
    </div>
  </div>


  <div fxLayout="row " *ngIf="formInit" fxShow fxHide.lt-md>

    <div fxLayout="row wrap" fxFlex="100" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">


      <ng-container *ngFor="let field of fields">

        <ng-container>

          <ng-container *ngIf="field.inputType !== 'button'; else buttonContainer">
            <div [fxFlex]="layout == 2 ? 
          (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
          : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
            : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
              : '100'))">

              <div dynamicField (valueChange)="onFieldValueChange($event)" [field]="field" [group]="form"></div>
            </div>
          </ng-container>
          <ng-template #buttonContainer>
            <div *ngIf="EnablePayment==0 && !enableFormPayment" fxFlex="100">
              <button class="primary" fxFlex [ngStyle]="{ 'color': disabledButton? 'gray' : 'white' }"
                [disabled]="disabledButton" (click)="onSubmit()" mat-raised-button>

                {{disabledButton?'Processing': field.label}}
                <mat-icon *ngIf="disabledButton">
                  <mat-spinner class="primary" diameter="20">
                  </mat-spinner>
                </mat-icon>
              </button>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>

      <!-- <div *ngIf="customField13==2" class="gapbottom" fxLayoutAlign="end center">
        <button fxFlex="100" (click)="newForm()"  type="submit" style="color:white" mat-raised-button
        class="primary">Submit</button>
      </div> -->

      <div *ngIf="formValid && enableFormPayment">
        <app-razor-pay [contact]="contact" [partialAmountEnabled]="0" (paymentStatus)="paymentResponceRazorPAy($event)"
          [finalAmount]="amount"></app-razor-pay>

      </div>

    </div>
  </div>

</div>


<div class="margin-t10" *ngIf="EnablePayment==1">


  <div class="gapbottom" fxLayoutAlign="center center">
    <button [disabled]="disabledButton" style="color: white; width: 150px; height: 45px;" class="primary" (click)="onSubmit()" mat-raised-button>
      Submit
    </button>
  </div>

  <div class="policy" style="padding-top: 4%; font-size: 20px;">
    I have read, understood, and hereby accept the User Agreement, Terms and Conditions along with Cancellation and 
    Refund Policy. I permit Webotel enterprise to process ahead with my subscription plan for my property. 
    I also expressly allow to store and process my information for further coordination and promotional activities. 
  </div>

  <div  fxLayoutAlign="center center" style="padding-top: 2%;">

    <div class="policy-container">
      <mat-card class="policy-card">
        <mat-card-header>
          <mat-card-title class="policy-title">Accept Our Policy Documents</mat-card-title>
          <mat-card-subtitle class="policy-subtitle">Please review and accept the following agreements</mat-card-subtitle>
        </mat-card-header>
    
        <mat-card-content>
          <form [formGroup]="termsForm" class="policy-form">
            <!-- User Agreement -->
            <mat-card class="policy-item" appearance="outlined">
              <div class="policy-content">
                <mat-checkbox formControlName="userAgreement" color="primary" class="policy-checkbox">
                  <span class="policy-label">User Agreement</span>
                </mat-checkbox>
                <button mat-icon-button (click)="policyPopup('userAgreement')" matTooltip="View User Agreement">
                  <mat-icon class="policy-icon">remove_red_eye</mat-icon>
                </button>
              </div>
            </mat-card>
    
            <!-- Terms & Conditions -->
            <mat-card class="policy-item" appearance="outlined">
              <div class="policy-content">
                <mat-checkbox formControlName="termsConditions" color="primary" class="policy-checkbox">
                  <span class="policy-label">Terms & Conditions</span>
                </mat-checkbox>
                <button mat-icon-button (click)="policyPopup('terms')" matTooltip="View Terms & Conditions">
                  <mat-icon class="policy-icon">remove_red_eye</mat-icon>
                </button>
              </div>
            </mat-card>
    
            <!-- Cancellation Policy -->
            <mat-card class="policy-item" appearance="outlined">
              <div class="policy-content">
                <mat-checkbox formControlName="cancellationPolicy" color="primary" class="policy-checkbox">
                  <span class="policy-label">Cancellation Policy</span>
                </mat-checkbox>
                <button mat-icon-button (click)="policyPopup('cancellationPolicy')" matTooltip="View Cancellation Policy">
                  <mat-icon class="policy-icon">remove_red_eye</mat-icon>
                </button>
              </div>
            </mat-card>
    
            <!-- Refund Policy -->
            <mat-card class="policy-item" appearance="outlined">
              <div class="policy-content">
                <mat-checkbox formControlName="refundPolicy" color="primary" class="policy-checkbox">
                  <span class="policy-label">Refund Policy</span>
                </mat-checkbox>
                <button mat-icon-button (click)="policyPopup('returnPolicy')" matTooltip="View Refund Policy">
                  <mat-icon class="policy-icon">remove_red_eye</mat-icon>
                </button>
              </div>
            </mat-card>
          </form>
        </mat-card-content>
      </mat-card>
    </div>

  </div>


  <div>
    <calsoft-subscription-plan [SuccessMessage]="SuccessMessage" [FailerMessage]="FailerMessage"
      [redirectUrl]="redirectUrl"   [enablePayment]="termsForm.valid" fxFlex="100" [type]="'3'"></calsoft-subscription-plan>
  </div>

</div>


<div class="margin-t10" *ngIf="showResult">
  <div *ngIf="calculaterEnable" class="result-card">
    <h3>Your Result</h3>
    <div class="result-value">
      <p>Revenue / Sales</p>
      <h2> {{calculatedValue}}/-</h2>
    </div>

    <div class="result-details" *ngFor="let item of mergedObj | keyvalue">
      <p>{{item.key}}</p>
      <p>{{item.value}}</p>


    </div>
    <!-- <button mat-raised-button color="primary">Get Started</button> -->
  </div>
</div>
